//#region libraries

// react
import React from 'react';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { setDarkMode, selectDarkMode } from '_redux/slices/timeline/theme';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// bootstrap
import { Form } from 'react-bootstrap';

//#endregion

const DarkModeToggle = () => {

    //#region redux
    const dispatch = useDispatch();
    const darkMode = useSelector(selectDarkMode);
    const usedTheme = useSelector(selectUsedTheme);
    //#endregion

    //#region functions
    const handleSwitch = () => {
        dispatch(setDarkMode(!darkMode));
    };
    //#endregion

    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    Dark Mode
                </span>

                {/* Toggle for modes */}
                <Form.Check
                    onChange={handleSwitch}
                    type="switch"
                    checked={darkMode}
                    value={darkMode}
                    style={{ marginLeft: '16px' }}
                />
            </div>

            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                Switch between light and dark mode across the timeline.
            </span>
        </div>
    );
};

export default DarkModeToggle;
